// Internal identifiers are references, never ISBNs or barcodes.
const psoCodeSqlPattern = "^(PSO-[A-F0-9]{20}|20[0-9]{11})$";
const psoCheckDigit = (base) => {
  if (!/^\d{12}$/.test(String(base))) throw new Error("Base PSO deve ter 12 dígitos.");
  return String(
    (10 -
      ([...String(base)].reduce((sum, digit, i) => sum + Number(digit) * (i % 2 ? 3 : 1), 0) %
        10)) %
      10
  );
};
const isPsoCode = (value) => {
  const code = String(value || "");
  return (
    /^PSO-[A-F0-9]{20}$/.test(code) ||
    (/^20\d{11}$/.test(code) && psoCheckDigit(code.slice(0, 12)) === code[12])
  );
};
const normalizeIsbn = (value) =>
  String(value || "")
    .replace(/[\s-]/g, "")
    .toUpperCase();
function isbnToEan(value) {
  const isbn = normalizeIsbn(value);
  if (/^\d{9}[\dX]$/.test(isbn)) {
    const sum = [...isbn].reduce(
      (total, digit, index) => total + (digit === "X" ? 10 : Number(digit)) * (10 - index),
      0
    );
    if (sum % 11) return null;
    const base = `978${isbn.slice(0, 9)}`;
    const check =
      (10 - ([...base].reduce((s, d, i) => s + Number(d) * (i % 2 ? 3 : 1), 0) % 10)) % 10;
    return `${base}${check}`;
  }
  if (!/^97[89]\d{10}$/.test(isbn)) return null;
  return [...isbn].reduce((s, d, i) => s + Number(d) * (i % 2 ? 3 : 1), 0) % 10 === 0 ? isbn : null;
}
const normalizeCode = (value) =>
  String(value || "")
    .replace(/[^a-z0-9]/gi, "")
    .toUpperCase();
function parseMatchedProductIds(value) {
  try {
    const parsed = typeof value === "string" ? JSON.parse(value || "[]") : value;
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
}
function attachBookCodes(orders, books) {
  return orders.map((order) => {
    const matchedProductIds = parseMatchedProductIds(order.matchedProductIds);
    const matches = new Set(matchedProductIds.map(normalizeCode));
    return {
      ...order,
      matchedProductIds,
      bookCodes: [
        ...new Set(
          books
            .filter((book) =>
              [book.trayProductId, book.reference, book.bookId, book.ean].some(
                (id) => id && matches.has(normalizeCode(id))
              )
            )
            .map((book) => book.internalCode)
            .filter(Boolean)
        ),
      ],
    };
  });
}
module.exports = {
  isPsoCode,
  psoCheckDigit,
  psoCodeSqlPattern,
  normalizeIsbn,
  isbnToEan,
  attachBookCodes,
  parseMatchedProductIds,
};
